(function ($) {
  $(function () {
    var $stickyNav = $('.sticky-nav');

    if ($stickyNav.length) {
      var $window = $(window);
      var stickyNav = (function () {
        var $header = $('header');
        var $section = $('section');
        var $stickyWrapper = $stickyNav.find('.sticky-nav__wrapper');
        var $stickyAnchor = $stickyNav.find('a');
        var $stickyItems = $stickyNav.find('.sticky-nav__item ');
        var $dropDownHead = $stickyNav.find('.dropdown');
        var prevSectionId = '';

        function initSticky() {
          var sticky = new Waypoint.Sticky({
            element: $stickyWrapper[0],
            wrapper: false,
            offset: getMainNavHeight()
          });
        }

        function activeStickyAnchorOnScroll() {
          var winScrollTop = $window.scrollTop();
          var winY = winScrollTop + getMainNavHeight() + getStickyNavHeight();
          stickyTop = $stickyNav.offset().top + getMainNavHeight();

          if (winScrollTop === 0) {
            $stickyAnchor.removeClass('active');
            prevSectionId = '';
            return false;
          }

          if ($('body').hasClass('scrolling-down')) {
            stickyTop = $stickyNav.offset().top;
          }
          
          $section.each(function() {
            var sectionId = $(this).attr('id');

            if (!!sectionId && sectionId !== prevSectionId) {
              var sectionTop = $(this).offset().top;
              var sectionBottom = sectionTop + $(this).outerHeight();

              if (winY >= sectionTop && winY <= sectionBottom) {
                toggleActiveOnStickyAnchor(sectionId);
                prevSectionId = sectionId;
              } 
            }
          });
        }

        function handleStickyAnchorClick(e) {
          e.preventDefault();
          
          var currentScrollPos = $(window).scrollTop();
          var anchorOffsetTop = getAnchorOffsetTop(this.hash);
          var scrollTopPos;

          if (currentScrollPos < anchorOffsetTop) {
            if ($(window).width() > 1023) {
              scrollTopPos = anchorOffsetTop - getStickyNavHeight() + 1;
            } else {
              scrollTopPos = anchorOffsetTop - getMainNavHeight() - getStickyNavHeight() + 1;
            }
          } else {
            scrollTopPos = anchorOffsetTop - getMainNavHeight() - getStickyNavHeight() + 1;
          }

          $('html, body').animate(
            {
              scrollTop: scrollTopPos
            },
            700
          );
        }

        function getMainNavHeight() {
          return $header.find('.main-nav').outerHeight();
        }

        function getStickyNavHeight() {
          return $stickyNav.outerHeight();
        }

        function toggleActiveOnStickyAnchor(sectionId) {
          if (sectionId && isAnchorInSticky(sectionId)) {
            var $anchorLink = $stickyNav.find('a[href="#' + sectionId + '"]');

            $stickyAnchor.removeClass('active');
            $anchorLink.addClass('active');
          } else {
            $stickyAnchor.removeClass('active');
          }
        }

        function getAnchorOffsetTop(anchor) {
          var $anchor = $(anchor);

          if ($anchor.length) {
            if ($anchor.hasClass('text-over-grey-box')) {
              return  $anchor.offset().top + parseInt($anchor.css('padding-top'), 10);;
            }
            
            return $anchor.offset().top;
          }
        }

        function isAnchorInSticky(id) {
          return $stickyNav.find('a[href="#' + id + '"]').length;
        }

        function dropDownHandler(e) {
          e.preventDefault();
          var dropdownTopValue = getStickyNavHeight() - ($(this).position().top - $(this).closest('.sticky-nav').position().top);

          $(this).toggleClass('dropdown--open');
          $(this).find('.dropdown__menu').slideToggle(300);
          
          if ($(this).closest('.sticky-nav__wrapper').hasClass('stuck')) {
            $(this).find('.dropdown__menu').css("top", $(this).closest('.sticky-nav').height() - ($(this).position().top + 2));
          } else {
            $(this).find('.dropdown__menu').css("top", dropdownTopValue);
          }
        }

        function initDropdown() {
          if ($dropDownHead.length) {
              if ($dropDownHead.hasClass('dropdown--open')) {
              $dropDownHead.find('.dropdown__menu').slideUp();
              $dropDownHead.removeClass('dropdown--open');
            }
          }
        }

        function handleNavBoxshadow() {
          if ($('.sticky-nav').length > 0) {
            $('body').addClass('no-shadow');
          }
        }

        function handleWidthOfLessItem() {
          if ($stickyItems.length <= 3) {
            $stickyNav.addClass('sticky-nav--less-items')
          }
        }

        return {
          init: function () {
            initSticky();
            activeStickyAnchorOnScroll();
            handleNavBoxshadow();
            handleWidthOfLessItem()
            this.bindEvents();
          },
          bindEvents: function () {
            $stickyAnchor.on('click', handleStickyAnchorClick);
            
            $dropDownHead.on('click', dropDownHandler);
          },
          activeStickyAnchorOnScroll: activeStickyAnchorOnScroll,
          initDropdown: initDropdown,
        }
      })();

      stickyNav.init();

      $window.on('load', function () {
        Waypoint.refreshAll();
      });

      $window.on('load scroll resize', stickyNav.activeStickyAnchorOnScroll);
      $window.on('resize', stickyNav.initDropdown);
    }
  });
})(jQuery);
